import React, { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setOther as updateOther } from '../redux/userSlice';
import { MinorUserContext } from "../context/UserNameProvider";
import Question from "../components/Question";
import ContinueButton from "../components/ContinueButton";
import { Box, TextField, FormControl } from "@mui/material";
import { textAreaSx } from "../lib/uiformatting";
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

export default function AnythingElse() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const user = useSelector((state) => state.user);
    const [other, setOther] = useState(user.other);

    const { isMinor, firstName } = useContext(MinorUserContext);

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/other-meds', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            title="Finally, describe your dermatology concern."
            subtitle={
                `How ${isMinor ? (firstName + "'s") : "your"} concern looks/feels. Any related symptoms (itching, redness, swelling, etc.). What soothes or worsens ${isMinor ? (firstName + "'s") : "your"} symptoms, if anything?`
            }
            input={
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <FormControl sx={{ width: "100%", mb: "2rem" }}>
                        <TextField
                            placeholder="Answer here..."
                            variant="outlined"
                            color="secondary"
                            sx={{ ...textAreaSx, width: "100%" }}
                            autoComplete="off"
                            multiline
                            rows={5}
                            value={other}
                            onChange={(e) => setOther(e.target.value)}
                        />
                    </FormControl>
                    <ContinueButton
                        onClick={() => {
                            dispatch(updateOther(other));
                            setPageAndDeferNavigate(dispatch, '/address', navigate);
                        }}
                        title="Continue"
                        selected={true}
                        disabled={user.concern === "Other / unsure" && other.trim() === ""}
                    />
                </Box>
            }
        />
    );
}